<script>
import UpdateUserForm from "../../components/forms/UpdateUserForm.vue";
export default {
  components: { UpdateUserForm },
  name: "ManageUserView",

  data() {
    return {
      allUsers: [],
      searchQuery: "",
      pagination: {
        page: 1,
        rowsPerPage: 20,
      },
      enableUserEditing: false,
      editUserObj: {},
      deleteUserInfo: {},
      notificationHandle: null,
    };
  },
  computed: {
    filteredRows() {
      return this.allUsers.filter((row) =>
        row.email.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedRows() {
      const start = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      const end = start + this.pagination.rowsPerPage;
      return this.filteredRows.slice(start, end);
    },
    maxPage() {
      return Math.ceil(this.filteredRows.length / this.pagination.rowsPerPage);
    },
  },
  methods: {
    //fetchUsers from API
    async fetchUsers() {
      try {
        const response = await this.$store.dispatch("getAllUsers");
        this.allUsers = response.data;

        // Additional operations after fetching users
        this.resetEdits();
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },

    resetEdits() {
      this.editUserObj = {};
      this.enableUserEditing = false;
      this.hideNotif();
    },

    async onUpdateSuccessHandler() {
      await this.fetchUsers();
    },

    editUser(user) {
      this.editUserObj = user;
      this.enableUserEditing = true;
      // Implement your edit logic here
    },

    //show notification
    showNotif(position) {
      this.notificationHandle = this.$q.notify({
        message: `Deleting user: ${this.deleteUserInfo.userName} is in progress.`,
        caption: "List will refresh soon!",
        color: "info",
        icon: "information",
        position,
        timeout: 0,
        progress: true,
      });
    },

    //hide notification
    hideNotif() {
      if (this.notificationHandle) {
        this.notificationHandle(); // This will dismiss the notification
        this.notificationHandle = null; // Clear the handle
        this.searchQuery = "";
      }
    },

    //confirmation dialog
    confirm() {
      this.$q
        .dialog({
          title: "User Deletion",
          message: `You are about to DELETE user with User Name: ${this.deleteUserInfo.userName}`,
          cancel: true,
          persistent: true,
          color: "secondary",
        })
        .onOk(async () => {
          try {
            this.showNotif("top");
            await this.$store.dispatch("deleteUser", {
              userId: this.deleteUserInfo.userId,
            });
            await this.fetchUsers();
          } catch (err) {
            console.error("Failed to delete user:", err);
            alert("Error deleting user");
          }
          // console.log('>>>> OK')
        })
        .onOk(() => {
          // console.log('>>>> second OK catcher')
        })
        .onCancel(() => {
          // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    },

    //delete user function
    async deleteUser(user) {
      this.deleteUserInfo = user;
      this.confirm();
    },
    onSearch() {
      this.pagination.page = 1; // Reset to the first page on a new search
    },
    previousPage() {
      if (this.pagination.page > 1) {
        this.pagination.page--;
      }
    },
    nextPage() {
      if (this.pagination.page < this.maxPage) {
        this.pagination.page++;
      }
    },
  },
  async mounted() {
    //invoke fetechuser function
    await this.fetchUsers();
  },
};
</script>
<template>
  <!-- Edit user component -->
  <div id="edit-users-div" v-if="enableUserEditing">
    <div style="background-color: #fff; max-width: 780px; margin: auto auto">
      <update-user-form
        :userInfo="editUserObj"
        @onCancel="resetEdits()"
        @onUpdateSuccess="onUpdateSuccessHandler()"
      />
    </div>
  </div>

  <!-- users list  -->
  <div id="manage-users-view" v-else>
    <div id="div__loaded" v-if="allUsers.length > 0">
      <div
        id="div_search"
        style="
          width: 95%;
          margin: auto auto;
          display: flex;
          justify-content: flex-end;
          padding: 8px auto;
          gap: 8px;
          align-items: center;
          background-color: #eee;
        "
      >
        <label for="inputSearch">Search user by email:</label>
        <input
          id="inputSearch"
          type="text"
          v-model="searchQuery"
          placeholder="Search by email"
          @input="onSearch"
        />
      </div>

      <table id="table_users" style="width: 95%; margin: auto auto">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Roles</th>
            <th>PBI Roles</th>
            <th style="text-align: center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in paginatedRows" :key="user.email">
            <td>{{ user.firstName }}</td>
            <td>{{ user.lastName }}</td>
            <td>{{ user.email }}</td>
            <td>
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  flex-direction: row;
                  column-gap: 4px;
                  row-gap: 4px;
                "
              >
                <div
                  v-for="role in user.roles"
                  :key="role.roleId"
                  style="
                    background-color: #ccc;
                    border-radius: 10px;
                    padding: 4px 8px;
                    font-size: 75%;
                  "
                >
                  {{ role.roleName }}
                </div>
              </div>
            </td>
            <td>
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  flex-direction: row;
                  column-gap: 4px;
                  row-gap: 4px;
                "
                v-if="user.pbi_roles.length > 0"
              >
                <div
                  v-for="role in user.pbi_roles"
                  :key="role.pbiRoleId"
                  style="
                    background-color: #ccc;
                    border-radius: 10px;
                    padding: 4px 8px;
                    font-size: 75%;
                  "
                >
                  {{ role.roleName }}
                </div>
              </div>
              <p v-else>-</p>
            </td>
            <td>
              <button @click="editUser(user)">Edit</button>
              &nbsp;
              <button @click="deleteUser(user)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination">
        <button @click="previousPage" :disabled="pagination.page === 1">
          Previous
        </button>
        <p>Page {{ pagination.page }} of {{ maxPage }}</p>
        <button @click="nextPage" :disabled="pagination.page === maxPage">
          Next
        </button>
      </div>
    </div>

    <!-- loading div, visible untill all user information is not fetched -->
    <div
      id="div__loading"
      style="
        width: 100%;
        height: 100%;
        min-height: calc(100vh - 100px);
        display: flex;
        align-items: center;
        justify-content: center;
      "
      v-else
    >
      <p>Loading...</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
#table_users {
  td,
  th {
    padding: 4px;
  }
  thead {
    background-color: #333;
    color: #fff;

    th {
      text-align: left;
      min-width: 120px;
    }
  }

  tbody {
    tr:nth-child(odd) {
      background-color: #ededed;
    }
    tr:nth-child(even) {
      background-color: #fff;
    }
  }
}

.pagination {
  width: 95%;
  margin: auto auto;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 20px;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 8px;

  p {
    margin: unset;
  }
}
</style>
